module.exports = __webpack_public_path__ + "static/media/Follower_Button-16.e00c216c.png";